import { IconButton, InputAdornment, withStyles } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
const CssTextField = withStyles({
  root: {
    color: "#fff",
    width: "100%",
    "&.compact-select-field": {
      "& .MuiInputBase-root": {
        minHeight: "20px !important",
        height: "auto !important",
        backgroundColor: "#ffffd6 !important",
        borderRadius: "0px !important",
        fontSize: "11px !important",
        padding: "0px !important",
      },
      "& .MuiOutlinedInput-input": {
        padding: "1px 18px 1px 4px !important",
        fontSize: "11px !important",
        minHeight: "18px !important",
        height: "auto !important",
        lineHeight: "1.2 !important",
        backgroundColor: "#ffffd6 !important",
        boxSizing: "border-box !important",
      },
      "& .MuiSelect-select": {
        padding: "1px 18px 1px 4px !important",
        fontSize: "11px !important",
        minHeight: "18px !important",
        height: "auto !important",
        lineHeight: "1.2 !important",
        backgroundColor: "#ffffd6 !important",
        display: "flex !important",
        flexWrap: "wrap !important",
        alignItems: "center !important",
        gap: "2px !important",
      },
      "& .MuiSelect-select:focus": {
        backgroundColor: "#ffffd6 !important",
      },
      "& .MuiSelect-icon": {
        top: "calc(50% - 7px) !important",
        right: "2px !important",
        fontSize: "14px !important",
      },
      "& fieldset": {
        borderColor: "#cbd5e1 !important",
        borderRadius: "0px !important",
        top: "0 !important",
      },
      "& legend": {
        display: "none !important",
      },
    },
    "& label": {
      color: "#313C4C",
    },
    "& label.Mui-focused": {
      color: "#313C4C",
    },
    "& .MuiOutlinedInput-inputMultiline": {
      padding: "0px",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "red",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        padding: "0px",
        borderColor: "#e1e1e1",
      },
      "&:hover fieldset": {
        padding: "0px",
        borderColor: "#e1e1e1",
        borderWidth: 1,
      },
      "&.Mui-focused fieldset": {
        borderColor: "#e1e1e1",
        borderWidth: 1,
      },
    },
  },
})(TextField);

function CustomTextField(props) {
  const {
    inputType = "text",
    name = "",
    value = "",
    error = false,
    errorMsg = "",
    onChange = () => { },
    ...others
  } = props;

  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  switch (inputType) {
    case "phone":
      return (
        <div style={{ position: "relative", width: "100%" }}>
          <PhoneInput
            country={"in"}
            value={value}
            onChange={(phone) => onChange({ target: { name, value: phone } })} // Updates the form state
            enableSearch
            inputStyle={{
              width: "100%",
              height: "56px",
              borderRadius: "4px",
              border: error ? "1px solid red" : "1px solid #ccc",
              fontSize: "16px",
              paddingLeft: "48px",
            }}
            buttonStyle={{
              borderRadius: "4px 0 0 4px",
            }}
            dropdownStyle={{
              zIndex: 1000,
            }}
          />
          {error && <span className="error-messages" style={{ color: "red" }}>{errorMsg}</span>}
        </div>
      );

    case "text":
      return (
        <div style={{ position: "relative", width: "100%" }}>
          <CssTextField
            name={name}
            value={value}
            error={error}
            onChange={onChange}
            variant="outlined"
            fullWidth
            {...others}
          />
          {error ? <span className="error-messages">{errorMsg}</span> : null}
        </div>
      );
    case "password":
      return (
        <div style={{ position: "relative", width: "100%" }}>
          <CssTextField
            type={showPassword ? "text" : "password"}
            name={name}
            value={value}
            error={error}
            onChange={onChange}
            variant="outlined"
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleTogglePasswordVisibility}
                    edge="end"
                    style={{ padding: '4px' }}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            {...others}
          />
          {error ? <span className="error-messages">{errorMsg}</span> : null}
        </div>
      );
    case "number":
      return (
        <div style={{ position: "relative", width: "100%" }}>
          <CssTextField
            name={name}
            type="number"
            value={value}
            error={error}
            onChange={onChange}
            variant="outlined"
            fullWidth
            {...others}
          />
          {error ? <span className="error-messages">{errorMsg}</span> : null}
        </div>
      );
    default:
      return <TextField />;
  }
}

export default CustomTextField;
